import Layout from '../components/Layout';

export default function Contexts() {
  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Context Management</h2>
          <p className="text-gray-600 mb-4">
            Organize your captures into meaningful contexts. AI will automatically categorize new captures.
          </p>

          {/* Add Context Button */}
          <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition mb-6">
            + New Context
          </button>

          {/* Context List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 transition cursor-pointer">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-semibold text-lg">Work</h3>
                <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">12 items</span>
              </div>
              <p className="text-sm text-gray-600">Meeting notes, project updates, tasks</p>
            </div>

            <div className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 transition cursor-pointer">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-semibold text-lg">Personal</h3>
                <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">8 items</span>
              </div>
              <p className="text-sm text-gray-600">Ideas, reminders, personal notes</p>
            </div>

            <div className="border-2 border-gray-200 rounded-lg p-4 hover:border-blue-400 transition cursor-pointer">
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-semibold text-lg">Events</h3>
                <span className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded">5 items</span>
              </div>
              <p className="text-sm text-gray-600">Conference materials, event photos</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
